module.exports = __webpack_public_path__ + "img/record.bbbffc8c.svg";